import {Box, Typography} from '@mui/material';
import './ExitJobModal.scss';
import {t} from 'i18next';
import ArrModal from '../../../../../common/arr-modal/ArrModal';
import {useNavigate} from 'react-router-dom';
import ArrButton from '../../../../../common/arr-button/ArrButton';
import './ExitJobModal.scss';
import {useDispatch, useSelector} from 'react-redux';
import {
  resetEditMode,
  resetFormData,
  setCloneJobName,
  setDefineCriteria,
  showToast,
} from '../../../../../../redux/slice/aiReviewSlice';
import {RootState} from '../../../../../../redux/store';
import {
  useCreateAIReviewJob,
  useUpdateAIReviewJob,
} from '../../../../../../hooks/ai/review/useReview';
import {ToastType} from '../../../../../../shared/constants';
import {CRITERIA} from '../issue-coding-type-header/IssueCodingTypeHeader';

interface ExitJobModalProps {
  open: boolean;
  onClose: () => void;
}

const ExitJobModal = ({open, onClose}: ExitJobModalProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jobType = useSelector((state: RootState) => state.aiReview.jobType);
  const formData = useSelector((state: RootState) => state.aiReview.formData);
  const {mutate: createAIReviewJob} = useCreateAIReviewJob();
  const {mutate: updateAIReviewJob} = useUpdateAIReviewJob();

  const handleConfirm = () => {
    navigate('/AI/Review');
    dispatch(setCloneJobName(''));
    dispatch(resetFormData());
    dispatch(resetEditMode());
    dispatch(setDefineCriteria(CRITERIA.MANUAL));

    onClose();
  };

  const triggerToast = () => {
    dispatch(
      showToast({
        title: t('ai.review.newJobDetail.draftToastTitle'),
        message: t('ai.review.newJobDetail.draftToastDesc', {
          value: formData?.jobDetail?.jobName,
        }),
        status: [ToastType.Success],
      })
    );
    navigate('/AI/Review');
    dispatch(setCloneJobName(''));
    dispatch(resetFormData());
    dispatch(resetEditMode());
    dispatch(setDefineCriteria(CRITERIA.MANUAL));
  };

  const handleDraft = () => {
    onClose();

    const issueCodeData = formData.contextAndCriteria.issueCodes.map((ic) => ({
      code: ic.code,
      question: ic.question,
    }));
    const payload = {
      jobType: jobType,
      jobName: formData.jobDetail.jobName,
      description: formData.jobDetail.description ?? '',
      groupID: Number(formData.jobDetail.selectedGroup?.id || -1),
      caseContext: formData.contextAndCriteria.context,
      issueCodes: issueCodeData,
      groundTruth: formData.groundTruth ?? '',
      relevanceCriteria: formData.contextAndCriteria.relevanceCriteria,
      sourceType: formData.sourceSelectionMode,
      sourceID: formData.sourceSelection ?? 0,
    };

    const mutationOptions = {
      onSuccess: async (data: any) => {
        if (data?.errorMessage) {
          dispatch(
            showToast({
              title: t('common.error'),
              message: data.errorMessage,
              status: [ToastType.Error],
            })
          );
          return;
        }
        triggerToast();
      },
      onError: (error: any) => {
        dispatch(
          showToast({
            title: t('common.error'),
            message:
              error?.response?.data?.detail ??
              error?.message ??
              t('common.error'),
            status: [ToastType.Error],
          })
        );
      },
    };

    if (formData.jobId) {
      updateAIReviewJob(
        {
          ...payload,
          jobId: formData.jobId,
        },
        mutationOptions
      );
    } else {
      createAIReviewJob(payload, mutationOptions);
    }
  };

  return (
    <>
      <ArrModal
        className="exitjobdetail"
        showModal={open}
        onClose={onClose}
        showClose={false}
        title={t('ai.review.newJobDetail.exitJobModalTitle')}
        aria-label="exit-job-detail-modal"
        dataTestId="arr-review-exit-job-detail-modal"
        buttons={[
          {
            id: 'draft-btn',
            label: t('ai.review.newJobDetail.exitJobModalDraftBtn'),
            onClick: handleDraft,
            disabled: !formData?.jobDetail.jobName,
            variant: 'text',
            dataTestId: 'ejd-draft-button',
            className: 'draft-button',
          },
        ]}
      >
        <Typography
          className="exitjobdetail-description"
          tabIndex={0}
          data-testid={`exit-job-modal-exit-job-modal-description`}
        >
          {t('ai.review.newJobDetail.exitJobModalDescription')}
        </Typography>
        <Box className="exit-modal-btn-container">
          <ArrButton
            variant="secondary"
            size="large"
            disabled={false}
            aria-label={t('ai.review.newJobDetail.exitJobModalDiscardBtn')}
            dataTestId="discard-btn"
            className="discard-btn"
            onClick={handleConfirm}
          >
            {t('ai.review.newJobDetail.exitJobModalDiscardBtn')}
          </ArrButton>
          <ArrButton
            variant="primary"
            size="large"
            disabled={false}
            aria-label={t('ai.review.newJobDetail.exitJobModalEditBtn')}
            dataTestId="edit-btn"
            className="edit-btn"
            onClick={onClose}
          >
            {t('ai.review.newJobDetail.exitJobModalEditBtn')}
          </ArrButton>
        </Box>
      </ArrModal>
    </>
  );
};

export default ExitJobModal;
